import React from "react";
import Productpage from "../../productpage2";
import SEO from "../../seo";

export default function OrthoCarePage({ location }) {
  const data = {
    galleryImages: [
      "https://eclipsemattress.in/assets/images/products/ortho-care/ORTHO-CARE-04.png",
      "https://eclipsemattress.in/assets/images/products/ortho-care/ORTHO-CARE-01.png",
      "https://eclipsemattress.in/assets/images/products/ortho-care/ORTHO-CARE-02.png",
      "https://eclipsemattress.in/assets/images/products/ortho-care/ORTHO-CARE-03.png",
    ],
    productName: "Ortho Care",
    productLogo:
      "https://eclipsemattress.in/wp-content/uploads/2020/01/Ortho-care11.png",
    descriptionTitle: "",
    descriptionText:
      "Combination of rebonded foam and custom made Eclipse high density Softy PU Foam . Ortho Series by Eclipse is the culmination of years of research to develop the most advanced version of firm mattress. This mattress is made up of high density PUF to provide enhance lumbar (lower back) support.",
    availableSizes: "5″",

    points: [
      "Combination of Rebonded Foam HD & custom made Eclipse high-density Softy PU Foam",
      "High lower back support",
      "Extra-firm mattress",
    ],
    category: { title: "Ortho Series", link: "/ortho-mattress/" },
    featuresText: [
      "Envelopes the spine in a gentle yet firm manner",
      "Pressure relieving material for restful sleep",
      "Recognised by leading chiropractors",
      "Supported and well ventilated Bonnell springs",
      "Anti-microbial mattress for proper toddler care",
      "Good and safe night’s rest guaranteed",
    ],
    // featuresImage:
    //   "https://eclipsemattress.in/wp-content/uploads/2020/01/Ortho17-1.png",
    warrantyIcons: [
      "https://eclipsemattress.in/assets/images/products/ortho-care/ORTHO-CARE-06.png",
      "https://eclipsemattress.in/assets/images/products/ortho-care/ORTHO-CARE-07.png",
      "https://eclipsemattress.in/assets/images/products/ortho-care/ORTHO-CARE-08.png",
      "https://eclipsemattress.in/assets/images/products/ortho-care/ORTHO-CARE-09.png",
      "https://eclipsemattress.in/assets/images/products/ortho-care/ORTHO-CARE-10.png",
    ],

    warrantyImage:
      "https://eclipsemattress.in/assets/images/products/ortho-care/ORTHO-CARE-05.png",
    price: "₹11,499 - ₹35,199",
    brochureLink:
      "https://eclipsemattress.in/assets/pdfs/Ortho-Collection-Brochure.pdf",
    relatedProducts: [
      {
        title: "Ortho Care ET",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/ortho-care-et.jpg",
        link: "/ortho-mattress/ortho-care-et/",
      },
      {
        title: "Orthospine",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/orthospine.jpg",
        link: "/ortho-mattress/orthospine/",
      },
      {
        title: "Orthotonic",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/orthotonic.jpg",
        link: "/ortho-mattress/orthotonic/",
      },
    ],
  };

  return (
    <div>
      <Productpage location={location} product={data} />
      <SEO
        title="Orthopedic Mattress For Back Pain | Eclipse International"
        description="Buy the ortho care Orthopedic mattress made with the combination of rebonded foam and high-density softy plush foam gives you comfort and spine support."
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-orthocare.jpg"
      />
    </div>
  );
}
